import React, { Fragment } from "react";
import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material";

import SelectOption from "./SelectOption";
import { isDark } from "@common/utils/colors";
import SkipButton from "./SkipButton";

const PREFIX = "Select";

const classes = {
  header: `${PREFIX}-header`,
  title: `${PREFIX}-title`,
  body: `${PREFIX}-body`,
  required: `${PREFIX}-required`,
  navigation: `${PREFIX}-navigation`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  borderRadius: "0px",
  boxShadow: "none",
  padding: theme.spacing(2, 3),
  width: "auto",
  backgroundColor: theme.palette.primary.main,
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },

  [`& .${classes.header}`]: {
    marginBottom: "20px",
  },

  [`& .${classes.title}`]: {
    fontWeight: 700,
    color: isDark(theme.palette.primary.main) ? "#FFF" : "#000",
  },

  [`& .${classes.body}`]: {
    display: "flex",
    flexDirection: "column",
    padding: 0,
  },

  [`& .${classes.required}`]: {
    color: theme.palette.error.main,
  },

  [`& .${classes.navigation}`]: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    padding: theme.spacing(0, 3),
    marginBottom: theme.spacing(2),
    height: 34,
  },
}));

const Select = ({ question, responses, setResponses, index, total, pageNum, setPageNum }) => {
  const theme = useTheme();

  return (
    <Fragment>
      <StyledBox>
        <div className={classes.header}>
          <Typography
            variant="body1"
            style={{ color: isDark(theme.palette.primary.main) ? "#FFF" : "#676767" }}
          >
            {index} of {total}
          </Typography>
          <Typography variant="h5" className={classes.title}>
            {question.question_title}
          </Typography>
          {question.required && <span className={classes.required}>* Required</span>}
        </div>
        <div className={classes.body}>
          {question.question_options &&
            question.question_options.map((option, i) => (
              <SelectOption
                key={i}
                option={option}
                value={responses[pageNum]}
                responses={responses}
                setResponses={setResponses}
                qnNum={pageNum}
                onNext={() => setPageNum(pageNum + 1)}
              />
            ))}
        </div>
      </StyledBox>
      <div
        className={classes.navigation}
        style={{ visibility: question.required ? "hidden" : "visible" }}
      >
        <SkipButton onClickFn={() => setPageNum(pageNum + 1)} />
      </div>
    </Fragment>
  );
};

export default Select;
